import React, { Component } from 'react';
import './Countdown.scss';

class Countdown extends Component {
  constructor(props) {
    super(props);
    this.now = new Date();

    this.state = {
      timeLapsed: 0,
      daysRemaining: '00',
      hoursRemaining: '00',
      minutesRemaining: '00',
      secondsRemaining: '00',
      countdownHasEnded: false,
    };
    this.formatTime = this.formatTime.bind(this);
    this.getTimeRemaining = this.getTimeRemaining.bind(this);
    this.secondsRemaining = this.secondsRemaining.bind(this);
    this.updateCountdown = this.updateCountdown.bind(this);
  }

  daysToSeconds(t) {
    return 24 * t * 60 * 60;
  }

  secondsRemaining() {
    const endDate = new Date(this.props.endDate);
    return Math.floor((endDate - this.now) / 1e3 - this.state.timeLapsed);
  }

  getTimeRemaining() {
    return this.formatTime(this.secondsRemaining());
  }

  componentDidMount() {
    this.updateCountdown(false);

    var interval = setInterval(() => {
      this.updateCountdown(interval);
    }, 1000);
  }

  updateCountdown(interval) {
    const currentTimeLapsed = this.state.timeLapsed;

    if (this.getTimeRemaining().total <= 0) {
      clearInterval(interval);
      this.setState({
        countdownHasEnded: true,
      });
    }
    this.setState({
      timeLapsed: currentTimeLapsed + 1,
      daysRemaining: this.getTimeRemaining().days,
      hoursRemaining: this.getTimeRemaining().hours,
      minutesRemaining: this.getTimeRemaining().mins,
      secondsRemaining: this.getTimeRemaining().seconds,
    });
  }
  formatTime(t) {
    return {
      days:
        Math.floor(t / 86400) < 10
          ? '0' + Math.floor(t / 86400)
          : Math.floor(t / 86400),
      hours:
        Math.floor((t / 3600) % 24) < 10
          ? '0' + Math.floor((t / 3600) % 24)
          : Math.floor((t / 3600) % 24),
      mins:
        Math.floor((t / 60) % 60) < 10
          ? '0' + Math.floor((t / 60) % 60)
          : Math.floor((t / 60) % 60),
      seconds:
        Math.floor(t % 60) < 10 ? '0' + Math.floor(t % 60) : Math.floor(t % 60),
      total: t,
    };
  }

  render() {
    return (
      !this.state.countdownHasEnded && (
        <div className="countdown" style={{ '--primaryColor': this.props.primaryColor || '#908871' }}>
          <div className="countdown__title">
            {this.props.title || 'Hurry, offer ends in'}
          </div>

          <div className="countdown__clock">
            <div className="countdown__panel">
              <span className="countdown__digits">
                {this.state.daysRemaining}
              </span>
              <div className="countdown__label">Days</div>
            </div>
            <div className="countdown__panel">
              <span className="countdown__digits">
                {this.state.hoursRemaining}
              </span>
              <div className="countdown__label">Hrs</div>
            </div>
            <div className="countdown__panel">
              <span className="countdown__digits">
                {this.state.minutesRemaining}
              </span>
              <div className="countdown__label">Mins</div>
            </div>
            <div className="countdown__panel">
              <span className="countdown__digits">
                {this.state.secondsRemaining}
              </span>
              <div className="countdown__label">Secs</div>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default Countdown;
